import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PETITION_UPDATE_EMAIL_PREVIEW_ENABLED = createFcmConfig('petition_update_email_preview_enabled', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
